import {
  Outlet,
  Link,
  useChildMatches,
  useNavigate,
} from '@tanstack/react-router';
import { Tabs, TabsList, TabsTrigger } from 'src/components/ui/tabs';
import { Button } from 'src/components/ui/button';
import { PlusIcon } from '@phosphor-icons/react';
import paths from 'src/paths';

export function AgentBuildersPage() {
  const firstChild = useChildMatches({ select: (matches) => matches[0] });
  const navigate = useNavigate();

  const activeRoute = firstChild?.routeId;
  let activeTab = 'definitions';
  if (
    activeRoute === '/authenticated/agents/' ||
    activeRoute?.startsWith('/authenticated/agents/$')
  ) {
    if (activeRoute === '/authenticated/agents/') {
      activeTab = 'definitions';
    } else {
      activeTab = 'agent-details';
    }
  }

  if (activeTab === 'agent-details') {
    return <Outlet />;
  }

  const handleCreateAgent = () => {
    void navigate({
      to: paths.authenticated.agents.detail,
      params: { agentId: 'new' } as any,
    });
  };

  return (
    <div className="p-6">
      <div className="mb-6 flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-bold">Agents</h1>
          <p className="text-muted-foreground mt-1">
            Create and manage AI agents with custom tools and permissions
          </p>
        </div>
        <Button onClick={handleCreateAgent}>
          <PlusIcon className="h-4 w-4 mr-2" />
          Create Agent
        </Button>
      </div>

      <Tabs value={activeTab} className="w-full">
        <TabsList>
          <TabsTrigger value="definitions" asChild>
            <Link to={paths.authenticated.agents.list}>Agents</Link>
          </TabsTrigger>
        </TabsList>
        <div className="mt-4">
          <Outlet />
        </div>
      </Tabs>
    </div>
  );
}
